import { render, staticRenderFns } from "./SmsPayment.vue?vue&type=template&id=65d7a64c&scoped=true&"
import script from "./SmsPayment.vue?vue&type=script&lang=js&"
export * from "./SmsPayment.vue?vue&type=script&lang=js&"
import style0 from "./SmsPayment.vue?vue&type=style&index=0&id=65d7a64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7a64c",
  null
  
)

export default component.exports